import {request} from './repository.js';

const url = 'dashboards/';

const dashboardRepository = {
    getDashboards(params) {
        return request.get(url, params);
    },

    getUniqueDashboard(id) {
        return request.get(url + id);
    },

    updateDashboard (id, data) {
        return request.put(url + id, data);
    },

    storeDashboard (data) {
        return request.post(url, data);
    },

    deleteDashboard (id) {
        return request.delete(url + id); 
    }
}

export default dashboardRepository;